import { ConflictType } from '@editor2/types/conflict';
import { ChapterChildrenReorderConflictResolver } from './childrenReorderResolver';
import { ChapterDeletedModifiedConflictResolver } from './deletedModifiedResolver';
import { ChapterModifiedDeletedConflictResolver } from './modifiedDeletedResolver';
import { ChapterPropertyConflictResolver } from './propertyResolver';

export class ChapterResolver {
	getTypeResolver = (key: ConflictType) => {
		switch (key) {
			case ConflictType.Property: {
				const resolver = new ChapterPropertyConflictResolver();
				return resolver;
			}

			case ConflictType.DeletedModified: {
				const resolver = new ChapterDeletedModifiedConflictResolver();
				return resolver;
			}

			case ConflictType.ModifiedDeleted: {
				const resolver = new ChapterModifiedDeletedConflictResolver();
				return resolver;
			}

			case ConflictType.ChildrenReorder: {
				const resolver = new ChapterChildrenReorderConflictResolver();
				return resolver;
			}

			default:
				break;
		}
	};
}
